<div class="composicao-prestador-container">
    <p-confirmDialog />

    <app-card-content [border]="false" [headerColor]="true" icon="pi pi-list" title="Composição" subtitle="Composição do corpo clínico do prestador">
        <div card-header class="inline-flex items-center gap-2">
            <app-botao-acoes label="Ações" [iconPos]="EInconPos.LEFT" [items]="itensAcoes" [destaque]="itensEdicao" [destaqueAtivo]="editandoTipo" [iconColumns]="2" [permissaoUf]="pessoa()?.uf ?? null" />
        </div>

        <div class="flex flex-col gap-4">
            <app-tab-container [(selected)]="selectedComposicao" [options]="composicaoOptions" [useHeader]="false" (onChanged)="alternarComposicao($event.value)">
                <app-tab-content [value]="'ATUAL'">
                    <ng-template [ngTemplateOutlet]="tableTemplate"></ng-template>
                </app-tab-content>
                <app-tab-content [value]="'ANTIGA'">
                    <ng-template [ngTemplateOutlet]="tableTemplate"></ng-template>
                </app-tab-content>
            </app-tab-container>
        </div>
    </app-card-content>
</div>

<p-dialog
    appDialogoPadrao="pi pi-users"
    descricao="Médicos que compõem o corpo clínico do prestador."
    [(visible)]="editando"
    (onHide)="cancelarEdicao()"
    [breakpoints]="{ '1100px': '70vw', '768px': '86vw', '500px': '94vw' }"
    header="Corpo Clínico"
    [style]="{ width: 'min(92vw, 1120px)' }"
    styleClass="dialog-fullscreen-mobile composicao-dialog"
    [maximizable]="true"
    [appendTo]="'body'"
>
    <ng-template #content>
        <form [formGroup]="form" class="p-fluid formgrid grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-x-5 gap-y-4">
            <div class="field">
                <label for="medicoNome" class="font-semibold block mb-2">Médico</label>
                <div class="flex flex-row gap-2 items-center">
                    <input fluid id="medicoNome" pInputText formControlName="medicoNome" readonly />
                    <p-button icon="pi pi-search" (click)="pesquisaMedicoDialog = true" />
                </div>
            </div>
            <div class="field">
                <label for="ufMedico" class="font-semibold block mb-2">UF</label>
                <input fluid id="ufMedico" pInputText formControlName="ufMedico" maxlength="2" />
            </div>
            <div class="field">
                <label for="dtEntrada" class="font-semibold block mb-2">Entrada</label>
                <input fluid id="dtEntrada" pInputText type="date" formControlName="dtEntrada" />
            </div>
            <div class="field">
                <label for="dtSaida" class="font-semibold block mb-2">Saída</label>
                <input fluid id="dtSaida" pInputText type="date" formControlName="dtSaida" />
                @if (form.controls.dtSaida.value) {
                    <small class="field-warning block mt-1"><i class="pi pi-exclamation-triangle"></i> Eventuais chefias técnicas ativas deste médico serão encerradas nesta data.</small>
                }
            </div>
            <div class="field">
                <label for="naturezaVinculo" class="font-semibold block mb-2">Vínculo</label>
                <p-select fluid id="naturezaVinculo" formControlName="naturezaVinculo" [options]="vinculoOptions" optionLabel="label" optionValue="value" appendTo="body" />
            </div>
            <!-- Vínculo 'J' (PSMT): o Delphi expõe e exige o prestador do PSMT. -->
            @if (exigePsmt) {
                <div class="field md:col-span-2">
                    <label for="psmtNome" class="font-semibold block mb-2">Prestador do PSMT</label>
                    <div class="flex flex-row gap-2 items-center">
                        <input fluid id="psmtNome" pInputText formControlName="psmtNome" readonly placeholder="Selecione o prestador do PSMT" />
                        <p-button icon="pi pi-search" (click)="pesquisaPsmtDialog = true" />
                    </div>
                    @if (form.controls.idSolicitantePsmt.invalid && form.controls.idSolicitantePsmt.touched) {
                        <small class="field-warning block mt-1"><i class="pi pi-exclamation-triangle"></i> Informe o prestador do PSMT.</small>
                    }
                </div>
                <div class="field">
                    <label for="ufPsmt" class="font-semibold block mb-2">UF PSMT</label>
                    <input fluid id="ufPsmt" pInputText formControlName="ufPsmt" maxlength="2" readonly />
                </div>
            }
        </form>
    </ng-template>

    <ng-template #footer>
        <p-button label="Cancelar" icon="pi pi-times" text (click)="cancelarEdicao()" />
        <p-button label="Salvar" icon="pi pi-check" [loading]="salvando()" (click)="salvar()" />
    </ng-template>
</p-dialog>

<ng-template #tableTemplate>
    <div class="flex flex-col gap-2 sm:flex-row sm:justify-end sm:items-center mb-2">
        <p-select class="w-full sm:w-40" [ngModel]="selectedTipo" [options]="tipoOptions" optionLabel="label" optionValue="value" [disabled]="!editandoTipo" (onChange)="alternarTipo($event.value)" appendTo="body" />
    </div>

    <app-custom-table
        [metadata]="tableMetadata"
        [data]="linhasTabela()"
        [columnOrder]="tableColumnOrder"
        [loading]="loading()"
        [rows]="10"
        [totalRecords]="linhasTabela().length"
        [rowsPerPageOptions]="[10, 20, 50]"
        [showActions]="true"
        [showExpandButton]="true"
        [cardColumns]="2"
        [permissaoUf]="pessoa()?.uf ?? null"
    ></app-custom-table>

    <div class="legend mt-3">
        <div class="legend-item"><span class="legend-color debt"></span>Médicos Devedores</div>
        <div class="legend-item"><span class="legend-color deceased"></span>Médicos Falecidos</div>
        <div class="ml-auto total">Total: {{ linhas().length || 0 }}</div>
    </div>
</ng-template>

<p-dialog
    appDialogoPadrao="pi pi-book"
    descricao="Especialidades do médico na composição."
    [(visible)]="especialidadesDialog"
    [breakpoints]="{ '1100px': '75vw', '500px': '90vw' }"
    header="Especialidades"
    styleClass="dialog-fullscreen-mobile"
    [maximizable]="true"
    [appendTo]="'body'"
>
    <ng-template #content>
        <div class="grid grid-cols-1 md:grid-cols-12 gap-4">
            <div class="md:col-span-6">
                <h6 class="box-title">Especialidade(s) Registrada(s)</h6>
                <p-table [loading]="especialidadesLoading" [paginator]="false" [value]="especialidadesRegistradas" styleClass="w-full">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Especialidade</th>
                            <th class="w-44">Área de atuação</th>
                        </tr>
                    </ng-template>
                    <ng-template let-r pTemplate="body">
                        <tr>
                            <td>{{ r.especialidade }}</td>
                            <td>{{ r.area }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>

            <div class="md:col-span-6">
                <h6 class="box-title">Especialidade(s) Declarada(s)</h6>
                <p-table [loading]="especialidadesLoading" [paginator]="false" [value]="especialidadesDeclaradas" styleClass="w-full">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Especialidade</th>
                            <th class="w-44">Área de atuação</th>
                        </tr>
                    </ng-template>
                    <ng-template let-d pTemplate="body">
                        <tr>
                            <td>{{ d.especialidade }}</td>
                            <td>{{ d.area }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </ng-template>

    <ng-template #footer>
        <p-button label="Fechar" icon="pi pi-times" text (click)="especialidadesDialog = false" />
    </ng-template>
</p-dialog>

<app-pesquisa [(showDialog)]="pesquisaMedicoDialog" [tipoFixo]="'MEDICO'" [apenasAtivos]="true" (pessoa)="selecionarMedico($event)"></app-pesquisa>
<app-pesquisa [(showDialog)]="pesquisaPsmtDialog" [tipoFixo]="'PRESTADOR'" [apenasAtivos]="true" (pessoa)="selecionarPsmt($event)"></app-pesquisa>
